







































































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import GenericEdit from '@/core/Generics/GenericEdit';
import Area from "@/models/coding/areaModel";
@Component
export default class LanguageEdit extends GenericEdit<Area> {
  constructor() {
    super();
    this.controller = 'Areas';
    this.model = new Area();
  }
    public validarCodigo(event: any) {
    if(event.keyCode === 32) {
      event.preventDefault();
    }
  }
}
